import React from "react";
import * as Icons from "lucide-react";
import GenericCRUD from "@/components/common/GenericCRUD";

const Stars = ({ n = 0 }) => (
  <div className="flex items-center gap-0.5">
    {Array.from({ length: 5 }).map((_, i) => (
      <Icons.Star key={i} className={`w-3.5 h-3.5 ${i < n ? "fill-[#F59E0B] text-[#F59E0B]" : "text-white/15"}`} />
    ))}
  </div>
);

const config = {
  resource: "testimonials",
  singular: "testimonial",
  title: "Testimonials",
  subtitle: "Client reviews and quotes.",
  titleKey: "author",
  statusFilter: ["approved", "pending"],
  columns: [
    { key: "author", label: "Author", render: (r) => <span className="text-white font-medium">{r.author || r.client_name}</span> },
    { key: "company", label: "Company" },
    { key: "rating", label: "Rating", render: (r) => <Stars n={r.rating} /> },
    { key: "featured", label: "Featured", render: (r) => r.featured
      ? <span className="text-[#F59E0B] text-xs">★ Featured</span>
      : <span className="text-white/40 text-xs">—</span>
    },
    { key: "status", label: "Status", badge: true, className: "w-32" },
  ],
  fields: [
    { key: "author", label: "Author Name", type: "text", hint: "Display name for the testimonial" },
    { key: "company", label: "Company / Service", type: "text" },
    { key: "role", label: "Role", type: "text" },
    { key: "quote", label: "Quote", type: "textarea" },
    { key: "avatar", label: "Author Photo", type: "image", folder: "testimonials", hint: "Upload a photo or pick from the media library" },
    { key: "initials", label: "Avatar Initials", type: "text", hint: "1-2 letters shown when no photo is set" },
    { key: "rating", label: "Rating (1–5)", type: "number" },
    { key: "featured", label: "Featured", type: "switch" },
    { key: "status", label: "Status", type: "select", options: [
      { label: "Pending", value: "pending" }, { label: "Approved", value: "approved" }
    ]},
  ],
  defaultValues: { status: "pending", featured: false, rating: 5, initials: "", avatar: "" },
};

export default function Testimonials() { return <GenericCRUD config={config} />; }
